<template>
  <div class="content c895">
    <h2>Televizor 1</h2>
  </div>
  <div class="content c590">
    <div class="popup popDev3" style="display:none;">
      <div class="inner">
        <h3>Ali ste prepričani, da želite izbrisati napravo?</h3>
        <div class="msg">
          <h3>Televizor</h3>
        </div>
        <div class="con">
          <p>Izbrišite napravo, če ste se zmotili pri njenih podatkih oziroma ste izbrali napačno napravo. Če bi želeli, jo lahko kasneje brez težav ponovno dodate.</p>
        </div>
        <div class="btns">
          <a
            href="javascript:void(0)"
            class="btn"
            title="Več"
            onclick="popupDelete(&quot;popDev3&quot;)"
          >NE, PREKLIČI</a>
          <a
            id="ctl00_ContentPlaceHolder1_lnkBtnDeleteDevice"
            class="btn"
            href="javascript:__doPostBack('ctl00$ContentPlaceHolder1$lnkBtnDeleteDevice','')"
          >DA, IZBRIŠI</a>
        </div>
      </div>
    </div>
    <div class="appliance">
      <table>
        <tbody>
          <tr>
            <td class="first">Televizor</td>
            <td>LED LCD 152 cm</td>
            <td class="last">
              <div class="tools">
                <a
                  href="javascript:void(0)"
                  title="Zbriši"
                  class="close"
                  onclick="popupDelete(&quot;popDev3&quot;)"
                >Zbriši</a>
              </div>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
    <div class="appliance data">
      <div class="icon">
        <span class="TV">Televizor</span>
      </div>
      <div class="first">
        <h5>TRENUTNA PORABA</h5>
        <span id="ctl00_ContentPlaceHolder1_lblConsumption">
          <span class="et">
            113 kWh / leto
            <div class="tooltip-bottom">
              Enotna tarifa (ET) je tarifa, ki jo beleži enotarifni števec vsak dan od 0.00 do 24.00 ure. Cena električne energije je ves čas enaka. V primeru, da imate enotarifno merjenje in želite dvotarifnega, pokličite v vaše elektrodistribucijsko podjetje za podrobnejše informacije.
              <br />
              <a
                href="http://www.uresnicujmo.si/o_aplikaciji_za_izracun_prihrankov/predstavitev#tarife"
                target="_blank"
                title="Več"
              >Več o tem &gt;</a>
            </div>
          </span>
        </span>
        <em>
          <span id="ctl00_ContentPlaceHolder1_lblTotalPrice">8,54 € / leto</span>
        </em>
      </div>

      <div class="no-data">
        <h5>VAŠI PRIHRANKI</h5>
        <h5>VAŠA NOVA PORABA</h5>
        <div class="message">
          <p>Za izračun nove porabe in prihrankov na izbrani napravi izvedi vsaj en ukrep.</p>
        </div>
      </div>
    </div>
    <div class="actions">
      <div class="toggle-btn" style="display:none;">
        <a href="javascript:void(0)" class="active">Prihranki zaradi izvedenih ukrepov</a>
      </div>
      <ul class="actionsExistingUl"></ul>

      <h3>Zmanjšajte porabo naprave Televizor</h3>
      <p>Zmanjšajte porabo tako, da izvedete vsaj enega, še bolje pa več, spodaj navedenih ukrepov. Izberite le tiste, ki so v vaših razmerah pomembni.</p>
      <ul>
        <li id="ctl00_ContentPlaceHolder1_RepeaterActions_ctl00_divAction">
          <a
            class="actionBtnMore active"
            style="cursor:pointer;"
          >Zamenjamo televizor z energijsko varčnejšim</a>

          <div style class="actionPnlMore">
            <div id="ctl00_ContentPlaceHolder1_RepeaterActions_ctl00_Panel7">
              <div class="form">
                <h3>Izberite lastnosti novega Televizorja:</h3>
                <fieldset>
                  <div class="f-item select">
                    <label>
                      Tip televizorja:
                      <span
                        id="ctl00_ContentPlaceHolder1_RepeaterActions_ctl00_RequiredFieldValidator10"
                        style="color:Red;float:none;font-size:1em;visibility:hidden;"
                      >*</span>
                      <span></span>
                    </label>
                    <select
                      name="ctl00$ContentPlaceHolder1$RepeaterActions$ctl00$ddlClassTV"
                      onchange="javascript:setTimeout('__doPostBack(\'ctl00$ContentPlaceHolder1$RepeaterActions$ctl00$ddlClassTV\',\'\')', 0)"
                      id="ctl00_ContentPlaceHolder1_RepeaterActions_ctl00_ddlClassTV"
                    >
                      <option selected="selected" value="0">Izberite</option>
                      <option value="122">LCD</option>
                      <option value="123">LED</option>
                    </select>
                    <!-- tooltip + div added-->
                    <div class="help">
                      <a href="#" class="help" title="Help">Help</a>
                      <div class="tooltip">
                        <p></p>
                      </div>
                    </div>
                    <!-- //end -->
                  </div>
                  <div class="f-item select">
                    <label>
                      Diagonala zaslona:
                      <span
                        id="ctl00_ContentPlaceHolder1_RepeaterActions_ctl00_RequiredFieldValidator11"
                        style="color:Red;float:none;font-size:1em;visibility:hidden;"
                      >*</span>
                      <span></span>
                    </label>
                    <select
                      name="ctl00$ContentPlaceHolder1$RepeaterActions$ctl00$ddlClassTV2"
                      id="ctl00_ContentPlaceHolder1_RepeaterActions_ctl00_ddlClassTV2"
                    >
                      <option value="0">Izberite</option>
                    </select>
                    <!-- tooltip + div added-->
                    <div class="help">
                      <a href="#" class="help" title="Help">Help</a>
                      <div class="tooltip">
                        <p></p>
                      </div>
                    </div>
                    <!-- //end -->
                  </div>
                </fieldset>
              </div>
            </div>

            <div class="advice">
              <div class="right">
                <a
                  id="ctl00_ContentPlaceHolder1_RepeaterActions_ctl00_lnkBtnAdd"
                  class="btn"
                  href="javascript:WebForm_DoPostBackWithOptions(new WebForm_PostBackOptions(&quot;ctl00$ContentPlaceHolder1$RepeaterActions$ctl00$lnkBtnAdd&quot;, &quot;&quot;, true, &quot;ChangeDevice&quot;, &quot;&quot;, false, true))"
                >Izvedi ukrep</a>
              </div>
              <p>30 % električne energije pri uporabi TV sprejemnika prihranimo, če TV sprejemnik s katodno cevjo zamenjavo za varčnejši LCD TV sprejemnik in 70 % električne energije prihranimo, če CRT zamenjamo za najbolj varčni LED LCD TV sprejemnik.</p>
            </div>
          </div>
        </li>

        <li id="ctl00_ContentPlaceHolder1_RepeaterActions_ctl01_divAction">
          <a class="actionBtnMore" style="cursor:pointer;">Izklapljamo iz vtičnice</a>

          <div style="display:none;" class="actionPnlMore">
            <div class="advice">
              <div class="right">
                <a
                  id="ctl00_ContentPlaceHolder1_RepeaterActions_ctl01_lnkBtnAdd"
                  class="btn"
                  href="javascript:__doPostBack('ctl00$ContentPlaceHolder1$RepeaterActions$ctl01$lnkBtnAdd','')"
                >Izvedi ukrep</a>
              </div>
              <p>40 % električne energije pri celotni uporabi TV sprejemnika prihranimo, če ga po uporabi izklopimo iz električnega omrežja (primer velja, če imamo TV vključen tri ure dnevno (kar je povprečni čas gledanja TV v Evropi) in 21 ur v pripravljenosti (stand by).</p>
            </div>
          </div>
        </li>
      </ul>
    </div>
    <div class="advice">
      <h4>Imejte vedno v mislih, da lahko prihranite!</h4>
      <p>Na porabo vaše naprave vplivajo različni dejavniki, od energetskega razreda do načina, kako jo uporabljate. Preberite dodatne nasvete, kako znižati porabo električne energije v vašem gospodinjstvu.</p>
      <a
        href="http://www.uresnicujmo.si/nasveti/tv"
        target="_blank"
        alt="več"
        class="more"
      >Preberite si več nasvetov</a>
    </div>
  </div>
  <div class="content r-c">
    <div class="c282">
      <h3>PORABA NAPRAVE TELEVIZOR 1</h3>
      <div class="select">
        <select
          name="ctl00$ContentPlaceHolder1$ddlUsageType"
          onchange="javascript:setTimeout('__doPostBack(\'ctl00$ContentPlaceHolder1$ddlUsageType\',\'\')', 0)"
          id="ctl00_ContentPlaceHolder1_ddlUsageType"
          class="s156"
        >
          <option selected="selected" value="1">Kumulativna poraba (€)</option>
          <option value="2">Kumulativna poraba (kWh)</option>
        </select>
        <select
          name="ctl00$ContentPlaceHolder1$ddlUsageTSpan"
          onchange="javascript:setTimeout('__doPostBack(\'ctl00$ContentPlaceHolder1$ddlUsageTSpan\',\'\')', 0)"
          id="ctl00_ContentPlaceHolder1_ddlUsageTSpan"
        >
          <option selected="selected" value="1">za 1 leto</option>
          <option value="5">za 5 let</option>
          <option value="10">za 10 let</option>
          <option value="15">za 15 let</option>
        </select>
      </div>

      <div class="graph">
        <div class="chart">
          <div
            id="ctl00_ContentPlaceHolder1_divCurrentUsage"
            class="col without"
            style="height:100%;"
          >
            <span id="ctl00_ContentPlaceHolder1_lblCurrentUsage">8,54 €</span>
          </div>
        </div>
        <div class="legend">
          <div class="col">
            <strong>Poraba brez</strong> izvedenih ukrepov
          </div>
          <div class="col">
            <strong>Poraba z</strong> izvedenimi ukrepi
          </div>
        </div>
      </div>
    </div>
    <div class="c282">
      <h3>PORABA NAPRAVE TELEVIZOR 1</h3>
      <div class="select">
        <select
          name="ctl00$ContentPlaceHolder1$ddlUsageType2"
          onchange="javascript:setTimeout('__doPostBack(\'ctl00$ContentPlaceHolder1$ddlUsageType2\',\'\')', 0)"
          id="ctl00_ContentPlaceHolder1_ddlUsageType2"
          class="s156"
        >
          <option selected="selected" value="1">Kumulativna poraba (€)</option>
          <option value="2">Kumulativna poraba (kWh)</option>
        </select>
        <select
          name="ctl00$ContentPlaceHolder1$ddlUsageTSpan2"
          onchange="javascript:setTimeout('__doPostBack(\'ctl00$ContentPlaceHolder1$ddlUsageTSpan2\',\'\')', 0)"
          id="ctl00_ContentPlaceHolder1_ddlUsageTSpan2"
        >
          <option value="1">za 1 leto</option>
          <option selected="selected" value="5">za 5 let</option>
          <option value="10">za 10 let</option>
          <option value="15">za 15 let</option>
        </select>
      </div>
      <div class="graph image">
        <div class="chart">
          <img
            id="ctl00_ContentPlaceHolder1_Chart1"
            src="/Images/Charts/Chart000008.png?def3fad6-b03e-474a-9353-86ae342bc810"
            alt
            usemap="#ctl00_ContentPlaceHolder1_Chart1ImageMap"
            style="height:168px;width:263px;border-width:0px;padding:0;"
          />
          <map
            name="ctl00_ContentPlaceHolder1_Chart1ImageMap"
            id="ctl00_ContentPlaceHolder1_Chart1ImageMap"
          >
            <area
              shape="poly"
              coords="198, 144, 198, 45, 198, 45, 257, 16, 257, 16, 257, 144, 198, 144"
              title="13.11.2025; 42,688430512"
              alt
            />
            <area
              shape="poly"
              coords="139, 144, 139, 74, 139, 74, 198, 45, 198, 45, 198, 144, 139, 144"
              title="13.11.2024; 34,1507444096"
              alt
            />
            <area
              shape="poly"
              coords="81, 144, 81, 103, 81, 103, 139, 74, 139, 74, 139, 144, 81, 144"
              title="13.11.2023; 25,6130583072"
              alt
            />
            <area
              shape="poly"
              coords="22, 144, 22, 132, 22, 132, 81, 103, 81, 103, 81, 144, 22, 144"
              title="13.11.2022; 17,0753722048"
              alt
            />
            <area
              shape="poly"
              coords="257, 144, 257, 16, 257, 16, 22, 132, 22, 132, 22, 144, 257, 144"
              title="13.11.2021; 8,5376861024"
              alt
            />
            <area
              shape="poly"
              coords="198, 144, 198, 45, 198, 45, 257, 16, 257, 16, 257, 144, 198, 144"
              title="13.11.2025; 42,688430512"
              alt
            />
            <area
              shape="poly"
              coords="139, 144, 139, 74, 139, 74, 198, 45, 198, 45, 198, 144, 139, 144"
              title="13.11.2024; 34,1507444096"
              alt
            />
            <area
              shape="poly"
              coords="81, 144, 81, 103, 81, 103, 139, 74, 139, 74, 139, 144, 81, 144"
              title="13.11.2023; 25,6130583072"
              alt
            />
            <area
              shape="poly"
              coords="22, 144, 22, 132, 22, 132, 81, 103, 81, 103, 81, 144, 22, 144"
              title="13.11.2022; 17,0753722048"
              alt
            />
            <area
              shape="poly"
              coords="257, 144, 257, 16, 257, 16, 22, 132, 22, 132, 22, 144, 257, 144"
              title="13.11.2021; 8,5376861024"
              alt
            />
            <area
              shape="poly"
              coords="198, 144, 198, 45, 198, 45, 257, 16, 257, 16, 257, 144, 198, 144"
              title="13.11.2025; 42,688430512"
              alt
            />
            <area
              shape="poly"
              coords="139, 144, 139, 74, 139, 74, 198, 45, 198, 45, 198, 144, 139, 144"
              title="13.11.2024; 34,1507444096"
              alt
            />
            <area
              shape="poly"
              coords="81, 144, 81, 103, 81, 103, 139, 74, 139, 74, 139, 144, 81, 144"
              title="13.11.2023; 25,6130583072"
              alt
            />
            <area
              shape="poly"
              coords="22, 144, 22, 132, 22, 132, 81, 103, 81, 103, 81, 144, 22, 144"
              title="13.11.2022; 17,0753722048"
              alt
            />
            <area
              shape="poly"
              coords="257, 144, 257, 16, 257, 16, 22, 132, 22, 132, 22, 144, 257, 144"
              title="13.11.2021; 8,5376861024"
              alt
            />
            <area
              shape="poly"
              coords="198, 144, 198, 45, 198, 45, 257, 16, 257, 16, 257, 144, 198, 144"
              title="13.11.2025; 42,688430512"
              alt
            />
            <area
              shape="poly"
              coords="139, 144, 139, 74, 139, 74, 198, 45, 198, 45, 198, 144, 139, 144"
              title="13.11.2024; 34,1507444096"
              alt
            />
            <area
              shape="poly"
              coords="81, 144, 81, 103, 81, 103, 139, 74, 139, 74, 139, 144, 81, 144"
              title="13.11.2023; 25,6130583072"
              alt
            />
            <area
              shape="poly"
              coords="22, 144, 22, 132, 22, 132, 81, 103, 81, 103, 81, 144, 22, 144"
              title="13.11.2022; 17,0753722048"
              alt
            />
            <area
              shape="poly"
              coords="257, 144, 257, 16, 257, 16, 22, 132, 22, 132, 22, 144, 257, 144"
              title="13.11.2021; 8,5376861024"
              alt
            />
            <area
              shape="poly"
              coords="198, 144, 198, 45, 198, 45, 257, 16, 257, 16, 257, 144, 198, 144"
              title="13.11.2025; 42,688430512"
              alt
            />
            <area
              shape="poly"
              coords="139, 144, 139, 74, 139, 74, 198, 45, 198, 45, 198, 144, 139, 144"
              title="13.11.2024; 34,1507444096"
              alt
            />
            <area
              shape="poly"
              coords="81, 144, 81, 103, 81, 103, 139, 74, 139, 74, 139, 144, 81, 144"
              title="13.11.2023; 25,6130583072"
              alt
            />
            <area
              shape="poly"
              coords="22, 144, 22, 132, 22, 132, 81, 103, 81, 103, 81, 144, 22, 144"
              title="13.11.2022; 17,0753722048"
              alt
            />
          </map>
        </div>
        <div class="legend">
          <ul>
            <li class="without">Poraba brez izvedenih ukrepov</li>
            <li class="with">Poraba z izvedenimi ukrepi</li>
          </ul>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {};
</script>

<style>
</style>